import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logoSignUp.png";
import google from "../assets/images/google.png";
import facebook from "../assets/images/facebook.png";
import "./SignIn.scss";
const SignIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const [formError, setFormError] = useState({
    username: null,
    password: null,
  });
  const [errorMsg, setErrorMsg] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const [loading, setLoading] = useState(false);
  const validateForm = () => {
    let errors = Object.keys(formData).reduce((acc, key) => {
      acc[key] = formData[key] === "" ? "Please enter your " + key : "";
      return acc;
    }, {});
    setFormError(errors);
    if (Object.values(errors).every((err) => err === "")) {
      return true;
    } else {
      return false;
    }
  };

  const handleLogin = async () => {
    setLoading(true);
    if (validateForm()) {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({
          email: formData.username,
          password: formData.password,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/auth/login`,
          requestOptions
        );
        const result = await response.json();

        if (!response.ok || !result.token || !result.user) {
          throw new Error(result.message || "Invalid email or password");
        }

        localStorage.setItem("token", result.token);
        localStorage.setItem("user", JSON.stringify(result.user));
        localStorage.setItem("role", result.user.role);
        await navigateUserProfile(result);
      } catch (error) {
        setErrorMsg("Login Failed! " + error);
        setTimeout(() => {
          setErrorMsg(null);
        }, 3000);
        console.error(error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const navigateUserProfile = async (result) => {
    if (result.user.role === "Clinician") {
      navigate("/patients"); // Clinicians go to "/patients"
    } else if (result.user.role === "Patient") {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/patients/id/${result.user.profile}`,
        {
          headers: {
            Authorization: `Bearer ${result.token}`,
          },
        }
      );
      const patientData = await res.json();
      navigate(`/patients/${patientData.uid}`);
    } else {
      console.error("Unknown role:", result.user.role);
    }
  };
  return (
    <div className="signIn-container">
      {errorMsg && (
        <div className="popUpContainer">
          <div className="popUp">
            <p className="h2">{errorMsg}</p>
          </div>
        </div>
      )}
      <div
        className="col centerAlign"
        style={{ margin: "auto", paddingTop: "1rem" }}
      >
        <img src={logo} alt="logo" />
        <div
          className="col loginForm"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleLogin();
            }
          }}
        >
          <div className="h1"> Welcome!</div>
          {location.state?.passwordReset && (
            <div className="b3 authSuccess authMessage">
              Password changed successfully. You can now log in.
            </div>
          )}
          <input
            type="text"
            name="username"
            placeholder="Username"
            onChange={(e) => handleChange(e)}
          />
          {formError["username"] && (
            <div className="b3 error">
              *{formError["username"] && formError["username"]}
            </div>
          )}
          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={(e) => handleChange(e)}
          />
          {formError["password"] && (
            <div className="b3 error">
              *{formError["password"] && formError["password"]}
            </div>
          )}
          <Link to="/forgot-password" className="b4 hippiBlue">
            Forgot Password?
          </Link>
          <button className="button1 h3" onClick={() => handleLogin()}>
            {loading ? "Logging in ..." : "Login"}
          </button>
          <div className="b3 textCenter">
            Not a member?{" "}
            <a href="/signup" className="hippiBlue b4">
              Signup Now
            </a>
          </div>
          <hr className="width100" />
          {/* <div className="textCenter b3">Or continue with</div>
          <div className="row b3 social-signIn-container">
            <button className="icon-buttons">
              <img src={google} alt="google" />
            </button>
            <button className="icon-buttons">
              <img src={facebook} alt="facebook" />
            </button>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default SignIn;
